module.exports = __webpack_public_path__ + "img/10988_ICE.d94a12cf.webp";